import React from 'react';
import {Col, DatePicker, Typography} from 'antd';
import dayjs from 'dayjs';
import {ErrorMessage, useFormikContext} from 'formik';
import {fieldColProps, labelStyle} from '../gridHelpers';

// MUI's DatePicker took a `views` array (e.g. ['year','month']); antd's
// DatePicker instead takes a single `picker` mode. Best-effort mapping —
// coarsest granularity present in `views` wins.
const pickerFromViews = (views?: string[]): 'date' | 'month' | 'year' => {
  if (!views || views.includes('day')) return 'date';
  if (views.includes('month')) return 'month';
  if (views.includes('year')) return 'year';
  return 'date';
};

export default function DatePickerBox(props) {
  const textField = props.field;
  const {setFieldValue, values} = useFormikContext<any>();

  return (
    <Col {...fieldColProps(textField)}>
      <Typography.Text style={labelStyle}>{textField?.fieldLabel}</Typography.Text>
      <DatePicker
        picker={pickerFromViews(textField.views)}
        placeholder={textField?.format}
        format={textField?.format}
        style={{width: '100%'}}
        disabled={textField.isDisabled ?? false}
        disabledDate={
          textField?.disablePast
            ? (current) => current && current < dayjs().startOf('day')
            : undefined
        }
        value={values[textField?.name] ? dayjs(values[textField?.name]) : null}
        onChange={(value) => setFieldValue(textField.name, value ? value.toDate() : null)}
      />
      <ErrorMessage name={textField.name} component="div" />
    </Col>
  );
}
